import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=6c3768e9&scoped=true&lang=css"
script.__scopeId = "data-v-6c3768e9"

export default script